/**
 * 天気の種類
 */
export const WEATHER_TYPE = {
  SUNNY: 'sunny', // 晴れ
  CLOUDY: 'cloudy', // 曇り
  RAINY: 'rainy', // 雨
  SNOWY: 'snowy', // 雪
} as const;

/** 天気の種類を表す型 */
export type WeatherType = (typeof WEATHER_TYPE)[keyof typeof WEATHER_TYPE];

/**
 * 風向（8方位）
 */
export const WIND_DIRECTION = {
  N: 'north', // 北
  NE: 'northeast', // 北東
  E: 'east', // 東
  SE: 'southeast', // 南東
  S: 'south', // 南
  SW: 'southwest', // 南西
  W: 'west', // 西
  NW: 'northwest', // 北西
} as const;

/** 風向（8方位）を表す型 */
export type WindDirection = (typeof WIND_DIRECTION)[keyof typeof WIND_DIRECTION];

/**
 * 天気予報データ
 */
export interface WeatherForecast {
  id: string; // 天気予報ID
  fieldId: string; // 圃場ID
  datetime: Date; // 日時（3時間刻み）
  weatherType: WeatherType; // 天気の種類
  temperature: number; // 気温（℃）
  windSpeed: number; // 風速（m/s）
  windDirection: WindDirection; // 風向
}
